// src/config/mixcloud.js
// ─────────────────────────────────────────────────────────────
//  REPLACE 'YOUR_MIXCLOUD_USERNAME' with the username segment
//  from your Mixcloud profile URL (https://www.mixcloud.com/<here>/)
// ─────────────────────────────────────────────────────────────
export const MIXCLOUD_USERNAME = 'utterradio';

export const MIXCLOUD_API_BASE = 'https://api.mixcloud.com';

export const MIXCLOUD_WIDGET_IFRAME_BASE =
  'https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&hide_artwork=1&mini=1';

export const PLAYLISTS_CONFIG_URL = '/playlists.json';
export const ALL_EPISODES_SLUG = 'all-episodes';